import { useAppDispatch, useAppSelector } from "@/hooks";
import { DINING_MODES } from "@/constants/global";
import { useMemo } from "react";
import { Avatar, ButtonBase } from "@mui/material";
import { HugeiconsIcon } from "@hugeicons/react";
import { setIsDineModeOpen } from "@/store/uiSlice";


const SelectedDineMode = () => {
    const dispatch = useAppDispatch();
    const selectedDineMode = useAppSelector((store) => store.order.flow);

    const selectedMode = useMemo(() => {
        return DINING_MODES.find((mode) => mode.id === selectedDineMode);
    }, [selectedDineMode])

    const handleModeSelection = () => {
        dispatch(setIsDineModeOpen(true));
    }

    if (!selectedMode) {
        return null;
    }

    return (
        <ButtonBase onClick={handleModeSelection} sx={{ borderRadius: '50%' }}>
            <Avatar
                sx={{
                    backgroundColor: selectedMode.color[500],
                    padding: 1
                }}
            >
                <HugeiconsIcon size={32} icon={selectedMode.icon} strokeWidth={1.5} />
            </Avatar>
        </ButtonBase>
    )
}

export default SelectedDineMode;
